import { useState, FormEvent } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const honeypot = formData.get('company_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      
      await fetch('https://readdy.ai/api/form/d9142os6ci2plld1oidg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-8 md:mb-12 mx-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20concept%20with%20warm%20lighting%2C%20newspaper%20headlines%20floating%20artistically%2C%20digital%20screen%20glow%2C%20modern%20media%20aesthetic%2C%20amber%20and%20teal%20color%20palette%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20no%20text%20no%20watermark%2C%20abstract%20news%20concept&width=1200&height=500&seq=cta-banner-01&orientation=landscape"
            alt="独家爆料"
            className="w-full h-auto object-cover"
          />
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading leading-snug mb-4">
          <span className="font-bold text-foreground-950">不想错过任何</span>
          <span className="italic font-light text-foreground-500"> 重磅爆料</span>
          <span className="font-bold text-foreground-950">？</span>
        </h2>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-snug mb-8">
          订阅推送 · 第一时间掌握真相
        </h2>

        {status === 'success' ? (
          <div className="max-w-md mx-auto py-4 px-6 rounded-full bg-accent-100 text-accent-800 text-sm font-medium">
            <i className="ri-check-line mr-2"></i>订阅成功！最新爆料将第一时间推送到你的邮箱
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
            data-readdy-form=""
          >
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱地址"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={status === 'loading'}
              className="w-full sm:flex-1 h-12 px-5 rounded-full bg-background-100 border border-background-300/60 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0 }}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto h-12 px-8 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-xs text-primary-600 mt-3">订阅失败，请稍后重试</p>
        )}

        <p className="text-xs text-foreground-500 mt-4">
          订阅即表示同意我们的
          <a href="#" className="text-primary-600 hover:text-primary-700 cursor-pointer mx-1">用户协议</a>
          和
          <a href="#" className="text-primary-600 hover:text-primary-700 cursor-pointer ml-1">隐私政策</a>
        </p>
      </div>
    </section>
  );
}